import React, { useState } from "react";
import { SecurityMeasureModel } from "@common/components/dotLegalSecurityMeasure/DotLegalSecurityMeasure.types.ts";
import DotLegalSecurityMeasure from "../../../common/components/dotLegalSecurityMeasure/DotLegalSecurityMeasure.tsx";
import { SelectableSecurityMeasure } from "../../../processingActivity/ProcessingActivity.types.ts";
import AddEditSecurityMeasureDialog from "../../../masterData/securityMeasure/addEditSecurityMeasureDialog/AddEditSecurityMeasureDialog.tsx";
import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery.ts";

export interface SystemSecurityMeasuresFieldProps {
    entityId: string;
    securityMeasures: Array<SecurityMeasureModel>;
    onChange: (securityMeasures: Array<SecurityMeasureModel>) => void;
    canManageMasterData: boolean;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    headerText?: string;
    tooltipText?: string;
    errorText?: string;
}

function SystemSecurityMeasuresField(props: SystemSecurityMeasuresFieldProps) {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [typedSecurityMeasure, setTypedSecurityMeasure] = useState("");

    const securityMeasuresQuery = useDotLegalQueryWithKey<Array<SelectableSecurityMeasure>>(
        "systemSecurityMeasures" + props.entityId,
        `/securitymeasures/${props.entityId}/system`,
        { enabled: !props.isPreview }
    );

    const onSaveSecurityMeasure = (id: any, name: string) => {
        const temp = [...props.securityMeasures];
        temp.push({ securityMeasureId: id.id, isMet: true, derivedFromSystem: [], isGlobal: false });
        props.onChange(temp);
        securityMeasuresQuery.refetch();
        setTypedSecurityMeasure("");
    };

    return (
        <>
            <DotLegalSecurityMeasure
                canManageMasterData={props.canManageMasterData}
                disabled={props.disabled}
                isLoading={securityMeasuresQuery.isLoading}
                securityMeasureOptions={securityMeasuresQuery.data ?? []}
                securityMeasures={props.securityMeasures}
                onSecurityMeasureChange={props.readOnly ? () => {} : props.onChange}
                setShowAddNewSecurityMeasure={setShowAddDialog}
                setTypedSecurityMeasure={setTypedSecurityMeasure}
                typedSecurityMeasure={typedSecurityMeasure}
                errorText={props.errorText}
            />

            {showAddDialog && !props.readOnly && (
                <AddEditSecurityMeasureDialog
                    open
                    isAdd
                    selectSecurityMeasure={{
                        name: typedSecurityMeasure,
                        description: "",
                        isGlobal: false,
                        isCustom: true,
                        businessAreaIds: [],
                        groupEntitiesIds: [],
                        securityMeasureType: undefined,
                    }}
                    onDialogClose={() => setShowAddDialog(false)}
                    onOkClick={onSaveSecurityMeasure}
                    refetch={() => {}}
                />
            )}
        </>
    );
}

export default SystemSecurityMeasuresField;
